import { render } from "./commonErrorModal.vue?vue&type=template&id=200b66d2&ts=true"
import script from "./commonErrorModal.ts?vue&type=script&lang=ts"
export * from "./commonErrorModal.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__